import { createContext } from "react";

const RecentlyViewedContext = createContext();

export default RecentlyViewedContext;
